import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

export default function useStatisticDebt(params) {
  return useSWR(
    {
      path: "/api/v1/inventory-notes/statistics-debt",
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
